export default __webpack_public_path__ + "static/vbc_logo-32d771cf16b1f1b23f071269e1c69405.png";